<template>
  <section v-if="hasStation" class="section-wrapp">
    <Breadcrumbs v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <embed :src="'/pdf/' + station.id + '.pdf'" type="application/pdf" width="100%" height="800px"/>
  </section>
  <section v-else class="section-wrapp">

  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import '@/assets/css/custom-scrollbar.scss'

export default {
  name: 'Schema',
  components: {
    Breadcrumbs
  },
  data () {
    return {
      settings: {

        swicher: true
      },
      stationViewPageParam: true
    }
  },
  mounted () {
    let id = this.$route.params.id
    this.$store.dispatch('station/findOne', id)
  },
  computed: {
    breadcrumbsData () {
      return [
        {
          title: this.station.title,
          url: '/station-view/' + this.station.id
        },
        {
          title: this.station.title + ' (Schema)',
          url: '#'
        }
      ]
    },
    station () {
      return this.$store.getters[ 'station/station' ]
    },
    hasStation () {
      return this.$store.getters[ 'station/hasStation' ]
    }
  }
}
</script>
